exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".Title__titleWrapper___1MKcd {\n  margin-bottom: 50px;\n}\n.Title__mainHeader___3TaAu {\n  text-transform: lowercase;\n  font-weight: 700;\n  color: #003973;\n  font-size: 1.4em;\n  letter-spacing: 1px;\n  margin-top: 55px;\n  margin-bottom: 0px;\n  max-width: 90%;\n  margin-left: 5%;\n}\n@media (min-width: 768px) {\n  .Title__mainHeader___3TaAu {\n    font-size: 2.3em;\n  }\n}\n@media (min-width: 1500px) {\n  .Title__mainHeader___3TaAu {\n    margin-top: 70px;\n  }\n}\n.Title__subtitle___NaKqU {\n  color: #003973;\n  margin: 8px;\n  line-height: 1.3em;\n  max-width: 80%;\n  margin-left: 10%;\n}\n@media (min-width: 1200px) {\n  .Title__subtitle___NaKqU {\n    margin-top: 10px;\n    margin-bottom: 10px;\n    line-height: 1em;\n  }\n}\n.Title__zipState___14yxP {\n  color: #003973;\n  font-weight: 600;\n  text-transform: lowercase;\n}\n", ""]);

// exports
exports.locals = {
	"titleWrapper": "Title__titleWrapper___1MKcd",
	"mainHeader": "Title__mainHeader___3TaAu",
	"subtitle": "Title__subtitle___NaKqU",
	"zipState": "Title__zipState___14yxP"
};


//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"modules":true,"localIdentName":"[name]__[local]___[hash:base64:5]"}!./~/stylus-loader!./src/components/title/Title.styl
// module id = 246
// module chunks = 0